import { useEffect, useRef, useState } from "react";
import { API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const SCREENSAVER_MS = 3 * 60 * 1000;   // 3 minutes
const LOGOUT_MS = 5 * 60 * 1000;        // 5 minutes — strict auto-logout on inactivity

export function InactivityGuard() {
  const { user, logout } = useAuth();
  const [saver, setSaver] = useState(false);
  const lastRef = useRef(Date.now());
  const saverRef = useRef(false);

  useEffect(() => { saverRef.current = saver; }, [saver]);

  useEffect(() => {
    const bump = () => {
      lastRef.current = Date.now();
      if (saverRef.current) setSaver(false);
    };
    const events = ["mousemove", "mousedown", "keydown", "touchstart", "scroll", "click", "wheel"];
    events.forEach((e) => window.addEventListener(e, bump, { passive: true }));
    const iv = setInterval(() => {
      // Master Admin is never auto-logged-out — their session stays until manual Logout.
      if (user && user.role === "admin") return;
      const idle = Date.now() - lastRef.current;
      if (idle >= LOGOUT_MS) { logout(); return; }
      if (idle >= SCREENSAVER_MS && !saverRef.current) setSaver(true);
    }, 1000);
    return () => {
      events.forEach((e) => window.removeEventListener(e, bump));
      clearInterval(iv);
    };
  }, [user, logout]);

  if (!saver) return null;
  return (
    <div data-testid="screensaver"
      className="fixed inset-0 z-[9999] bg-[#0a1f44] flex flex-col items-center justify-center cursor-none select-none"
      onClick={() => setSaver(false)}>
      <div className="screensaver-logo">
        <img src={`${API}/settings/logo`} alt="ICDH" className="h-44 w-44 object-contain drop-shadow-2xl" />
      </div>
      <p className="text-white/80 mt-10 text-base font-semibold tracking-wide">Institution Chrétienne D'Haïti</p>
      <p className="text-white/40 mt-2 text-xs tracking-widest uppercase">Session verrouillée — bougez la souris pour reprendre</p>
    </div>
  );
}
